import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=5f997ce4&scoped=true&"
import script from "./Pages.vue?vue&type=script&lang=ts&"
export * from "./Pages.vue?vue&type=script&lang=ts&"
import style0 from "./Pages.vue?vue&type=style&index=0&id=5f997ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f997ce4",
  null
  
)

export default component.exports